module.exports = __webpack_public_path__ + "static/teck_3-5bc607da3f1d836c89b955c63bdefc88.jpg";